import axios from 'axios';

document.addEventListener('DOMContentLoaded', function(){

    const loaderButton = document.querySelector('[data-load-html]');
    
    loaderButton?.addEventListener('click', async (e) => {
            
        // get container and url from clicked button
        const loaderContainer = document.querySelector('[data-load-html-container]');
        const url = new URL(loaderButton.getAttribute('data-load-html'), document.baseURI);
        
        if ( !loaderContainer || !url ) return;

        e.preventDefault();

        // request to server
        loaderButton.classList.add('active');
        loaderButton.setAttribute('disabled', true);

        try {
            const response = await axios.get(url.href);
            const { data } = response;
            
            // append data to content
            loaderContainer.insertAdjacentHTML('beforeend', data.data);

            if ( data.enablePagination )
            {
                // if list continues

                // increment page in url
                let nextPage = Number(url.searchParams.get('page')) + 1;
                url.searchParams.set('page', nextPage);

                // append to a button
                loaderButton.setAttribute('data-load-html', url.href);
            }
            else
            {
                // hide button if list doesnt continue
                loaderButton.classList.add('d-none');
            }
        }
        catch (err) {
            console.error(err);
        }
        finally {
            loaderButton.classList.remove('active');
            loaderButton.removeAttribute('disabled');
        }

    });

});